import { PocTypography } from 'commons/components/components-wrapper';
import { withOptionalLabel } from 'commons/utils/optional-label.utils';
import { useTranslation } from 'core/i18n/i18n';
import { InputStyledSection } from './input-section.style';

type AlignLabelType = 'row' | 'column';

export interface InputSectionProps extends React.PropsWithChildren {
    title: React.ReactElement | string | null;
    description?: string | null;
    optional?: boolean;
    alignLabel?: AlignLabelType;
    className?: string;
}

export const InputSection = (props: InputSectionProps) => {
    const { title, description, alignLabel = 'row', optional = false, className = '', children } = props;
    const { t } = useTranslation();
    return (
        <InputStyledSection className={`${className} ${alignLabel}`}>
            {title || description ? (
                <div>
                    {typeof title === 'string' ? (
                        <PocTypography variant={'subtitle1'}>{withOptionalLabel(t, title, optional)}</PocTypography>
                    ) : (
                        title
                    )}
                    {description ? (
                        <PocTypography variant={'body2'} className="description">
                            {description}
                        </PocTypography>
                    ) : undefined}
                </div>
            ) : undefined}
            {children}
        </InputStyledSection>
    );
};
